import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=179fd085"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=179fd085&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports